var _path, _path2, _rect, _rect2, _circle, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h45v45H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFF",
    d: "M-1085-632H835V448h-1920z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -371,
    y: -482,
    width: 493,
    height: 780,
    rx: 26.182,
    fill: "#ECF2FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -314,
    y: -23,
    width: 379,
    height: 92,
    rx: 12,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#ECF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 31,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M7 6h31v31H7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.438 34.417c-2.325 0-4.306-.818-5.942-2.454-1.636-1.636-2.454-3.617-2.454-5.942v-.743c-1.852-.301-3.39-1.168-4.618-2.6-1.227-1.431-1.84-3.115-1.84-5.053v-7.75h3.875V8.584h2.583v5.166h-2.584V12.46h-1.291v5.166c0 1.421.506 2.637 1.518 3.65 1.011 1.01 2.228 1.517 3.649 1.517 1.42 0 2.637-.506 3.649-1.518 1.011-1.012 1.517-2.228 1.517-3.649V12.46H21.21v1.291h-2.584V8.584h2.584v1.291h3.875v7.75c0 1.938-.614 3.622-1.841 5.053-1.227 1.432-2.766 2.299-4.618 2.6v.743c0 1.615.565 2.987 1.695 4.118 1.13 1.13 2.503 1.695 4.118 1.695 1.614 0 2.987-.565 4.117-1.695 1.13-1.13 1.695-2.503 1.695-4.118v-2.163a3.762 3.762 0 0 1-1.857-1.39 3.756 3.756 0 0 1-.726-2.26c0-1.076.377-1.99 1.13-2.744.753-.754 1.668-1.13 2.745-1.13 1.076 0 1.991.376 2.745 1.13.753.753 1.13 1.668 1.13 2.745 0 .84-.242 1.593-.726 2.26a3.761 3.761 0 0 1-1.858 1.389v2.163c0 2.325-.818 4.306-2.454 5.942-1.636 1.636-3.616 2.454-5.941 2.454ZM31.542 21.5c.366 0 .672-.124.92-.372.247-.247.371-.553.371-.92a1.25 1.25 0 0 0-.371-.92 1.249 1.249 0 0 0-.92-.371c-.366 0-.673.123-.92.37a1.25 1.25 0 0 0-.372.922c0 .366.124.672.372.92.247.247.554.371.92.371Z",
    fill: "#006CC9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -401,
    y: -509,
    width: 553,
    height: 840,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_557",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -344,
    y: -50,
    width: 439,
    height: 152,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_557",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalAccountIcon);
export default __webpack_public_path__ + "static/media/medical_account_icon.68f735f8c273b07b2affac86ebe8e0da.svg";
export { ForwardRef as ReactComponent };